import script from "./artmisadsButtonSpecial.vue?vue&type=script&setup=true&lang=js"
export * from "./artmisadsButtonSpecial.vue?vue&type=script&setup=true&lang=js"

import "./artmisadsButtonSpecial.vue?vue&type=style&index=0&id=2dedd12f&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dedd12f"]])

export default __exports__